import { CSSProperties } from "react";

/**
 * Estilos padrão do container principal
 */
export const containerStyles: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  width: "400px",
  height: "600px",
  border: "1px solid #e0e0e0",
  borderRadius: "12px",
  overflow: "hidden",
  backgroundColor: "#ffffff",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
};

/**
 * Estilos padrão do header
 */
export const headerStyles: CSSProperties = {
  padding: "16px 20px",
  backgroundColor: "#007bff",
  color: "#ffffff",
  borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
};

/**
 * Estilos padrão do título do header
 */
export const headerTitleStyles: CSSProperties = {
  margin: 0,
  fontSize: "18px",
  fontWeight: 600,
  letterSpacing: "0.3px",
};

/**
 * Estilos padrão do container de mensagens
 */
export const messagesContainerStyles: CSSProperties = {
  flex: 1,
  overflowY: "auto",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  backgroundColor: "#f8f9fa",
};

/**
 * Estilos padrão de mensagem do usuário
 */
export const messageUserStyles: CSSProperties = {
  alignSelf: "flex-end",
  maxWidth: "75%",
  padding: "12px 16px",
  borderRadius: "18px 18px 4px 18px",
  backgroundColor: "#007bff",
  color: "#ffffff",
  wordWrap: "break-word",
  boxShadow: "0 2px 4px rgba(0, 123, 255, 0.2)",
};

/**
 * Estilos padrão de mensagem do bot
 */
export const messageBotStyles: CSSProperties = {
  alignSelf: "flex-start",
  maxWidth: "75%",
  padding: "12px 16px",
  borderRadius: "18px 18px 18px 4px",
  backgroundColor: "#ffffff",
  color: "#212529",
  wordWrap: "break-word",
  border: "1px solid #e9ecef",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
};

/**
 * Estilos padrão do conteúdo da mensagem
 */
export const messageContentStyles: CSSProperties = {
  margin: 0,
  fontSize: "14px",
  lineHeight: "1.5",
};

/**
 * Estilos padrão do timestamp da mensagem
 */
export const messageTimestampStyles: CSSProperties = {
  fontSize: "11px",
  marginTop: "6px",
  opacity: 0.7,
};

/**
 * Estilos padrão do container de input
 */
export const inputContainerStyles: CSSProperties = {
  display: "flex",
  padding: "16px 20px",
  gap: "12px",
  backgroundColor: "#ffffff",
  borderTop: "1px solid #e9ecef",
};

/**
 * Estilos padrão do input
 */
export const inputStyles: CSSProperties = {
  flex: 1,
  padding: "12px 16px",
  border: "1px solid #ced4da",
  borderRadius: "24px",
  fontSize: "14px",
  outline: "none",
  transition: "border-color 0.2s",
};

/**
 * Estilos padrão do botão de enviar
 */
export const sendButtonStyles: CSSProperties = {
  width: "52px",
  height: "52px",
  padding: 0,
  paddingRight: "4px",
  backgroundColor: "#007bff",
  color: "#ffffff",
  border: "none",
  borderRadius: "50%",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.2s",
  flexShrink: 0,
};

/**
 * Estilos padrão do botão desabilitado
 */
export const sendButtonDisabledStyles: CSSProperties = {
  backgroundColor: "#6c757d",
  cursor: "not-allowed",
  opacity: 0.6,
};

/**
 * Estilos padrão do indicador de carregamento
 */
export const loadingIndicatorStyles: CSSProperties = {
  textAlign: "center",
  padding: "12px",
  color: "#6c757d",
  fontSize: "13px",
  fontStyle: "italic",
};

/**
 * Estilos padrão de mensagem de erro
 */
export const errorMessageStyles: CSSProperties = {
  padding: "12px 16px",
  color: "#dc3545",
  backgroundColor: "#f8d7da",
  border: "1px solid #f5c6cb",
  borderRadius: "8px",
  fontSize: "13px",
  textAlign: "center",
  margin: "0 20px 16px",
};

/**
 * Estilos do botão toggle flutuante (mode: window)
 */
export const toggleButtonStyles: CSSProperties = {
  position: "fixed",
  bottom: "20px",
  right: "20px",
  width: "56px",
  height: "56px",
  borderRadius: "50%",
  backgroundColor: "#4f46e5",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#ffffff",
  boxShadow: "0 4px 12px rgba(79, 70, 229, 0.4)",
  transition: "all 0.3s ease",
  zIndex: 9998,
};

/**
 * Estilos do container do widget em mode window
 */
export const windowModeContainerStyles: CSSProperties = {
  position: "fixed",
  bottom: "90px",
  right: "20px",
  width: "420px",
  height: "600px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  overflow: "hidden",
  backgroundColor: "#ffffff",
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
  zIndex: 9999,
  transition: "all 0.3s ease",
};

/**
 * Merge estilos customizados com estilos padrão
 */
export const mergeStyles = (
  defaultStyle: CSSProperties,
  customStyle?: CSSProperties
): CSSProperties => {
  if (!customStyle) return defaultStyle;
  return { ...defaultStyle, ...customStyle };
};
